// public/js/components/tooltip.js

export default function Tooltip(rootEl) {
  const trigger = rootEl.querySelector('[data-ref="trigger"]');
  const content = rootEl.querySelector('[data-ref="content"]');

  if (!trigger || !content) {
    return;
  }

  const contentId = content.id || `tooltip-${Math.random().toString(36).substring(2, 11)}`;
  content.id = contentId;
  trigger.setAttribute('aria-describedby', contentId);

  let hideTimer = null;

  const show = () => {
    clearTimeout(hideTimer);
    content.classList.remove('invisible', 'opacity-0');
    content.classList.add('opacity-100');
    document.addEventListener('keydown', handleEscape);
  };

  const hide = () => {
    content.classList.remove('opacity-100');
    content.classList.add('invisible', 'opacity-0');
    document.removeEventListener('keydown', handleEscape);
  };

  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      hide();
    }
  };

  trigger.addEventListener('mouseenter', show);
  trigger.addEventListener('focus', show);

  trigger.addEventListener('mouseleave', () => {
    hideTimer = setTimeout(hide, 200);
  });
  trigger.addEventListener('blur', () => {
    hideTimer = setTimeout(hide, 200);
  });

  content.addEventListener('mouseenter', () => clearTimeout(hideTimer));
  content.addEventListener('mouseleave', () => {
    hideTimer = setTimeout(hide, 200);
  });
}